import { useEffect } from "react";
import useScreen from "./useScreen";

interface UseTipsAndTermsParams {
  acceptTerms: boolean;
  isOpenTdC: boolean;
  showTips: boolean;

  onOpenTdC: () => void;
  setShowTips: (value: boolean) => void;
}

const useTipsAndTerms = (params: UseTipsAndTermsParams) => {
  const { isOpenTdC, acceptTerms, onOpenTdC, setShowTips, showTips } = params;
  const { isMobile, width } = useScreen();

  useEffect(() => {
    if (width !== 0 && !isOpenTdC && !acceptTerms) {
      onOpenTdC();
    }
  }, [width]);

  useEffect(() => {
    if (acceptTerms && isMobile && !showTips) {
      setShowTips(true);
    }
  }, [acceptTerms]);

  useEffect(() => {
    if (!isMobile && !acceptTerms && !showTips) {
      setShowTips(true);
    }
  }, [isMobile]);

  return {};
};

export default useTipsAndTerms;
